/* eslint-disable */
import { outreachService } from '../_services'

const state = {
  count: 0,
  items: [],
  stats: {},
  statsLoading: false,
  customerOutReachContacts: [],
  customerOutReachContactsCount: 0,
  customerViews: [],
  itemsLoading: false,
  customerViewsLoading: false,
  corcsLoading: false,
  page: 1,
}

const actions = {
  fetchAll({ commit }, args = null) {
    commit('setItemsLoading', true)
    outreachService.getItems(args).then((response) => {
      console.log(">>>>>>}")
      commit('updateItems', response.data.results)
      commit('updateCount', response.data.count)
    }).finally(() => {
      commit('setItemsLoading', false)
    })
  },
  /** Fetch outreach stats. If customerId is specified, fetch only for that specific customer. */
  fetchStats({ commit }, {id, customerId = null}) {
    commit('setStatsLoading', true)
    outreachService.getStats(id, customerId).then((response) => {
      commit('updateStats', response.data)
    }).finally(() => {
      commit('setStatsLoading', false)
    })
  },
  reset({ commit }) {
    commit('reset')
  },
  fetchCustomerOutreachContact({ commit }, args) {
    commit('setCorcsLoading', true)
    return outreachService.getCustomerOutReachContacts(args).then((response) => {
      commit('saveCustomerOutReachContacts', response.data.results);
      commit('saveCustomerOutReachContactsCount', response.data.count)
      return response
    }).finally(() => {
      commit('setCorcsLoading', false)
    })
  },
  addCustomerOutreachContact({ commit }, args) {
    commit('setCorcsLoading', true)
    return outreachService.getCustomerOutReachContacts(args).then((response) => {
      commit('appendCustomerOutReachContacts', response.data.results);
      commit('saveCustomerOutReachContactsCount', response.data.count)
      return response
    }).finally(() => {
      commit('setCorcsLoading', false)
    })
  },
  fetchViews({ commit }, customerId) {
    if (!customerId) {
      console.warn('Will not fetchViews without a valid customerId')
      return
    }
    commit('setCustomerViewsLoading', true)
    outreachService.getCustomerOutReachContacts({ customer_id: customerId }).then((response) => {
      commit('saveCustomerViews', response.data.results);
    }).finally(() => {
      commit('setCustomerViewsLoading', false)
    })

    // TODO get album views
  },
  clearCustomerViews({commit}) {
    commit('clearCustomerViews');
  },
}

const mutations = {
  updateCount(state, count) {
    state.count = count
  },
  updateItems(state, items) {
    state.items = items
  },
  updateStats(state, stats) {
    state.stats = stats
  },
  reset(state) {
    state.items = []
    state.count = 0
    state.stats = {}
    state.customerOutReachContacts = []
    state.customerOutReachContactsCount = 0
    state.customerViews = []
  },
  saveCustomerOutReachContacts(state, response) {
    state.customerOutReachContacts = response;
  },
  saveCustomerOutReachContactsCount(state, count) {
    state.customerOutReachContactsCount = count
  },
  saveCustomerViews(state, response) {
    state.customerViews = response
  },
  setItemsLoading(state, isLoading) {
    state.itemsLoading = isLoading
  },
  setStatsLoading(state, isLoading) {
    state.statsLoading = isLoading
  },
  setCustomerViewsLoading(state, isLoading) {
    state.customerViewsLoading = isLoading
  },
  setCorcsLoading(state, isLoading) {
    state.corcsLoading = isLoading
  },
  appendCustomerOutReachContacts(state, items) {
    state.customerOutReachContacts.push(...items)
  },
  clearCustomerViews(state) {
    state.customerViews = []
  },
  setPage(state, page) {
    state.page = page;
  }
};

export const outreachs = {
  namespaced: true,
  state,
  actions,
  mutations,
}
